import { render, staticRenderFns } from "./Feature6.vue?vue&type=template&id=a01e8536"
import script from "./Feature6.vue?vue&type=script&lang=js"
export * from "./Feature6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports